import { render, staticRenderFns } from "./BidFollowProcessDetail.vue?vue&type=template&id=54aaf3f6&scoped=true&"
import script from "./BidFollowProcessDetail.vue?vue&type=script&lang=js&"
export * from "./BidFollowProcessDetail.vue?vue&type=script&lang=js&"
import style0 from "./BidFollowProcessDetail.vue?vue&type=style&index=0&id=54aaf3f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aaf3f6",
  null
  
)

export default component.exports